export default "__VITE_ASSET__BOwJZ95P__"